export class SwitchboardServer {
    id: number;
    name: string;
    server_host: string;
    registration_host: string;
    outbound_server_id: number;
}
